import { render, staticRenderFns } from "./biddingDialog.vue?vue&type=template&id=a573f27a&scoped=true"
import script from "./biddingDialog.vue?vue&type=script&lang=js"
export * from "./biddingDialog.vue?vue&type=script&lang=js"
import style0 from "./biddingDialog.vue?vue&type=style&index=0&id=a573f27a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a573f27a",
  null
  
)

export default component.exports